import styled from "styled-components";
import Lottie from "react-lottie";

export const SpinnerContent = styled(Lottie)`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
